import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import CustomCheckBox from "../../../components/UI/customCheckBox/customCheckBox";
import { Get, Post } from "../../../apis/api";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { useSelector } from "react-redux";
import { Separate } from "../../../utils/separate";
import CustomButton from "../../../components/UI/customButton/customButton";
import { toast } from "react-toastify";
import moment from "moment-jalaali";
import { redirect, useLocation, useParams, useSearchParams } from "react-router-dom";
import Switch from "../../../components/switch/switch";
import { CrewIcon, DockIcon, FlyIcon, HashtagIcon, ShipIcon, VisasIcon } from "../../../icons/icons";
import { useNavigate } from 'react-router-dom'
import { useVisaRegister } from './zustand';
import Loading from '../../../components/Loading';
const SendRequestStep = ({ changeStep, activeStep }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [paymentType, setPaymentType] = useState(false)
  const [paymentCredit, setPaymentCredit] = useState(false)
  const [disable, setDisable] = useState(false)
  const [role, setRole] = useState(false)
  const lng = useSelector((state) => state.common.lng)
  const user = useSelector((state) => state.user.user)

  const { back, forward } = useVisaRegister()

  const [searchParam, setSearchParam] = useSearchParams()

  // const data=record.data


  const id = useSelector((state) => state.user?.user.id)

  const handleList = () => {
    setLoading(true)
    Get(`agent/visas/show/${localStorage.getItem("visaId")}`).then((res) => {
      setData(res?.details?.data)
    })
      .catch((error) => {
        toast.error(error?.data?.message || error?.data?.msg);
      })
      .finally(() => {
        setLoading(false)
      })
  }




  const handleSubmit = () => {
    setLoading(true);
    Post(`agent/visas/payment/${localStorage.getItem("visaId")}`, { payment_method: (!paymentType && !paymentCredit) ? "online" : paymentType ? "wallet" : "credit" })
      .then((res) => {
        if (!paymentType && !paymentCredit) {
          window.location.assign(res.details.url)
        } else {
          setSearchParam({ 'trackId': res?.details?.q })
          forward()
          setDisable(true)
          toast.success(res.message || res.msg);
        }
      })
      .catch((error) => {
        console.log(error)
        setLoading(false);

        toast.error(error.data.message || error.data.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (activeStep)
      handleList()
  }, [activeStep])

  console.log({data})

  if (loading)
    return <>
      <div className='flex flex-row justify-center items-center gap-4 text-gray-900 w-full h-72 bg-white'>
        <span>{t('LoadingVisa')}</span>
        <Loading />
      </div>
      <LoadingFix />
    </>

  return (
    <div className={`my-container ${activeStep ? "h-auto" : "h-0 overflow-hidden "}`}>

      <div className={"grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 !mt-5"}>
        <div className={"grid gap-3"}>
          <div className={" relative bg-white rounded-lg border border-gray-400 flex flex-col gap-3 w-full py-5 px-9 "}>
            <div className={"text-gray-900 text-lg font-light mb-2 font-medium"}>
              {t("buyerDetails")}
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("agentCode") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{Separate(data?.agent_id)}</span>
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("agentName") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${user?.name + " " + user?.last_name}`}</span>
            </div>
          </div>
          <div className={" relative bg-white rounded-lg  flex flex-col gap-3 w-full  p-5 rounded-lg border border-gray-400"}>
            <div className={"text-gray-900 text-lg font-light mb-2 px-4 font-medium"}>
              {t("requestDetails")}
            </div>
            <div className={"flex"}>
              <HashtagIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("requestCode") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{data?.visa_id}</span>
            </div>
            <div className={"flex"}>
              <CrewIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("crewName") + " : "}</span>
              <div>
                {
                  data?.crews?.map((item) => {
                    return (
                      <div className={"text-gray-900 text-base font-normal"}>{item?.crew?.name + " " + item?.crew?.last_name}</div>
                    )
                  })
                }
              </div>
            </div>
            <div className={"flex"}>
              <VisasIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("visaType") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{data?.visa?.[`${lng}_name`]}</span>
            </div>
            <div className={"flex"}>
              <DockIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("port") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${data?.dock?.name}`}</span>
            </div>
            <div className={"flex border-b pb-2 "}>
              <ShipIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("ship") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`کشتی ${data?.ship?.name} -  مالکیت  ${data?.ship?.owner}`}</span>
            </div>
           
           {data?.destination_dock?.id && <div className={"flex  "}>
              <DockIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("DockOfDist") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${data?.destination_dock?.name ?? '-'}`}</span>
            </div>}

            {data?.exit_airport?.id && <div className={"flex "}>
              <FlyIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("ExitAirport") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${data?.exit_airport?.[lng=='fa' ? 'fa_name' : 'en_name' ] ?? '-'}`}</span>
            </div>}

            {data?.exit_date && <div className={"flex"}>
              <FlyIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("ExitDate") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${moment(data?.exit_date).format('jYYYY-jMM-jDD')  ?? '-'}`}</span>
            </div>}


            {data?.visa_fly?.length >0 && <div className={"flex"}>
              <FlyIcon />
              <span className={"text-gray-900 text-sm font-normal min-w-[100px] md:min-w-[120px]"}>{t("stepThree") + " : "}</span>
              <div className={"flex flex-col gap-2"}>
                <div className={"text-gray-900 text-base font-normal"}>{`${data?.visa_fly?.length > 1 ? t("two") : t("one")} مسیره `}</div>

                {

                  data?.visa_fly?.map((item) => {
                    return (
                      <div>
                        <div className={"text-gray-900 text-base font-normal"}>{` ایرلاین  ${item.airline[`${lng}_name`]}`}</div>
                        <div
                          className={"text-gray-900 text-base font-normal "}>{`پرواز: ${moment(item.fly_date).format(' HH:mm  /  jDD-jMM-jYYYY')}`}</div>
                        <div
                          className={"text-gray-900 text-base font-normal"}>{`رسیدن: ${moment(item.land_date).format(' HH:mm  /  jDD-jMM-jYYYY')}`}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>}


          </div>
          <div className={" relative bg-tertiary-100 rounded-lg border border-gray-400 flex flex-col gap-3 w-full py-2 px-9 "}>
            <div className={"text-gray-900 text-sm font-light "}>
              {t("requestAlarm")}
            </div>
          </div>
        </div>
        <div className={"grid grid-cols-1 gap-3"}>
          <div className={" relative bg-white rounded-lg border border-gray-400  flex flex-col gap-3 w-full  py-5 px-9 "}>
            <div className={"text-gray-900 text-lg font-light mb-2  font-medium"}>
              {t("calculate")}
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("baseCost") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{Separate(data?.visa?.price) + " تومان "}</span>
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("numberOfPeople") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{`${data?.crews?.length} نفر `}</span>
            </div>
            <div className={"flex border-t pt-4"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("finalAmount") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{Separate(data?.visa?.price * data?.crews?.length) + " تومان "}</span>
            </div>
          </div>

          <div className={" relative bg-white rounded-lg border border-gray-400 flex flex-col gap-3 w-full  py-5 px-9 "}>
            <div className={"mb-1"}>
              <Switch label={t("payFromWallet")} name={"payFromWallet"} onchange={(e) => setPaymentType(!paymentType)} />
            </div>
            <div className={"mb-1"}>
              <Switch label={t("PaymentFromCredit")} name={"PaymentFromCredit"} onchange={(e) => setPaymentCredit(!paymentCredit)} />
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("totalCredits") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{"--  تومان"}</span>
            </div>
            <div className={"flex"}>
              <span className={"text-gray-900 text-sm font-normal min-w-[80px] md:min-w-[90px]"}>{t("finalAmount") + " : "}</span>
              <span className={"text-gray-900 text-base font-normal"}>{"-- تومان"}</span>
            </div>
            <div className={"flex border-t pt-4"}>
              <span className={"text-primary-400 text-lg font-normal min-w-[80px] md:min-w-[90px]"}>{t("Payable") + " : "}</span>
              <span className={"text-primary-400 text-lg font-normal"}>{Separate(data?.full_price) + " تومان "}</span>
            </div>
          </div>
          <div className={"mt-1"}>
            <span className={"text-gray-900 text-lg font-light "}>
              {t("personalInformationPartOne")}
            </span>
            <span className={"text-gray-900 text-lg font-light underline"}>
              {t("personalInformationPartTwo")}
            </span>
            <span className={"text-gray-900 text-lg font-light "}>
              {t("personalInformationPartThree")}
            </span>
          </div>
          <div>
            <CustomCheckBox onCheck={() => setRole(!role)} label={"acceptRole"} />
          </div>
        </div>
      </div>
      <div className={"flex justify-between  pt-10  items-center"}>
        <div onClick={back} className={"text-main cursor-pointer"}>{t("prevStep")}</div>
        <div className={"min-w-[330px]"}>
          <CustomButton disable={disable || !role} loading={loading} onClick={() => handleSubmit()} title={"PaymentGateway"} />
        </div>
      </div>
    </div>
  );
};

export default SendRequestStep;
